"use client";

import { useState } from "react";
import Image from "next/image";

const videos = [
  {
    id: 1,
    thumbnail: "/images/ct1.webp",
    embed: `https://player.vimeo.com/video/975144609?h=23b5eda56e&autoplay=1`,
  },
  {
    id: 2,
    thumbnail: "/images/ct2.webp",
    embed: `https://player.vimeo.com/video/975150090?h=e9b21e5103&autoplay=1`,
  },
  {
    id: 3,
    thumbnail: "/images/ct3.webp",
    embed: `https://player.vimeo.com/video/975144836?h=8c9159bb82&autoplay=1`,
  },
];

const VideoTestimonials = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  return (
    <section className="w-full py-6 md:py-16">
      <div className="w-[90%] md:w-[80%] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Large video thumbnail */}
          <div className="col-span-1 md:col-span-2">
            <div
              className="relative w-full aspect-video rounded-xl overflow-hidden cursor-pointer"
              onClick={() => setActiveVideo(1)}
            >
              <Image
                src={videos[0].thumbnail}
                alt="testimonial 1"
                fill
                className="object-cover"
                unoptimized
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <Image
                  src="/images/ctplay.svg"
                  alt="play button"
                  width={64}
                  height={64}
                  className="w-16 h-16"
                  unoptimized
                />
              </div>
            </div>
          </div>

          {/* Right column with 2 thumbnails */}
          <div className="flex flex-col md:gap-4 gap-6">
            {videos.slice(1).map((video) => (
              <div
                key={video.id}
                className="relative w-full aspect-video rounded-xl overflow-hidden cursor-pointer"
                onClick={() => setActiveVideo(video.id)}
              >
                <Image
                  src={video.thumbnail}
                  alt={`testimonial ${video.id}`}
                  fill
                  className="object-cover"
                  unoptimized
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <Image
                    src="/images/ctplay.svg"
                    alt="play button"
                    width={56}
                    height={56}
                    className="w-14 h-14"
                    unoptimized
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Overlay Player */}
        {activeVideo && (
          <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
            <div className="relative w-[90%] md:w-[70%] lg:w-[60%] aspect-video rounded-xl overflow-hidden">
              <iframe
                src={videos.find((v) => v.id === activeVideo).embed}
                className="w-full h-full"
                frameBorder="0"
                allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
                allowFullScreen
                title={`Testimonial ${activeVideo}`}
              ></iframe>

              {/* Close Button */}
              <button
                onClick={() => setActiveVideo(null)}
                className="absolute top-3 right-3 text-white text-3xl font-bold hover:text-gray-300 z-10"
                aria-label="Close video"
              >
                ×
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default VideoTestimonials;
